export const getAlsConfig = (state, data) => {
  state.alsConfig.triggers = data.triggers;
  state.alsConfig.colors = data.colors;
  state.alsConfig.loading = data.loading;
  state.alsConfig.retrieved = data.retrieved;
};
